export default __webpack_public_path__ + "static/33F324_6_0-6960a6a4dc17d182877dad8135a7516c.ttf";